import { render } from "./ErrorCircleIcon.vue?vue&type=template&id=c7d26782&scoped=true"
const script = {}

import "./ErrorCircleIcon.vue?vue&type=style&index=0&id=c7d26782&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c7d26782"

export default script